export default async (context) => {
    // получаем список видео с коноцвками

    await context.$axios.get('/ending')
        .then(({ data }) => {

            if(data.length > 0) {

                let videos = []

                data.forEach(item => {
                    if(item.duration && (item.video || item.webm)) {
                        videos.push({
                            status: false,
                            control: 'ending',
                            type: 'video',
                            ...item
                        })
                    }
                })

                if(videos.length) {
                    context.videos = [...videos]

                    context.$nextTick(() => {
                        context.rendering = true
                    })

                    context.overlay = false
                    context.error.status = false
                    context.error.text = ''
                } else {
                    context.error.text = 'Список концовок для этой темы пуст. Пожалуйста, выберите другую тему.'
                    context.overlay = true
                    context.error.status = true
                }

            } else {
                context.error.text = 'Список концовок для этой темы пуст. Пожалуйста, выберите другую тему.'
                context.overlay = true
                context.error.status = true
            }

        })
        .catch(e => {
            console.error(e)
            context.error.text = 'Ошибка сервера! Не удалось получить список видео. Повторите попытку позже.'
            context.overlay = true
            context.error.status = true
        })
}